/**
 * Income navigation for the user panel — the six Alpha One income types plus
 * Achievement Rewards. Deliberately does NOT include the legacy ROI, royalty or
 * pool screens; those belong to a different compensation plan.
 */
export const INCOME_TABS = [
  { label: 'Direct Referral', to: '/income/direct-referral' },
  { label: 'Level Income', to: '/income/level-income' },
  { label: 'Alpha Club A', to: '/income/alpha-club-a' },
  { label: 'Alpha Club B', to: '/income/alpha-club-b' },
  { label: 'Elite Rank', to: '/income/elite-rank' },
  { label: 'Achievement Rewards', to: '/income/achievement-rewards' },
];
